import axios from 'axios';
import { demoConfig } from '../config/demoConfig';

const API_BASE_URL = demoConfig.backendApi;

export interface Message {
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
}

export interface ChatResponse {
  message: string;
  conversationId?: string;
}

class ChatService {
  private conversationId: string | null = null;

  async sendMessage(
    message: string,
    conversationHistory: Message[]
  ): Promise<ChatResponse> {
    try {
      // Format history for API (remove timestamps)
      const formattedHistory = conversationHistory.map(msg => ({
        role: msg.role,
        content: msg.content,
      }));

      const response = await axios.post<ChatResponse>(
        `${API_BASE_URL}/chat`,
        {
          message,
          conversationHistory: formattedHistory,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            ...(this.conversationId && {
              'x-conversation-id': this.conversationId,
            }),
          },
          timeout: 30000, // 30 second timeout
        }
      );

      if (response.data.conversationId) {
        this.conversationId = response.data.conversationId;
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.code === 'ECONNABORTED') {
          throw new Error('Request timeout. Please try again.');
        }
        if (error.response?.status === 429) {
          throw new Error(
            'Too many requests. Please wait a moment and try again.'
          );
        }
        if (error.response?.data?.error) {
          throw new Error(error.response.data.error);
        }
      }
      throw new Error(
        'Failed to send message. Please check your connection and try again.'
      );
    }
  }

  resetConversation() {
    this.conversationId = null;
  }
}

export const chatService = new ChatService();
